<!--Coming soon starts-->
<section id="coming-soon">
  <div class="container-fluid">
    <div class="row auth-height full-height-vh">
      <div class="col-12 d-flex align-items-center justify-content-center">
        <div class="card card-coming-soon box-shadow-0 overflow-hidden">
          <div class="card-header text-center pt-4 pb-3">
            <img alt="avtar" class="img-fluid" src="assets/meander.png"
              width="300">
          </div>
          <div class="card-content">
            <div class="card-body text-center pt-1">
              <h2 class="mb-3 mt-2">Email or Phone Already Enrolled</h2>
              <p class="mb-4" style="max-width: 500px;">You can login to check further process!</p>
              <a type="button" class="btn btn-primary mb-2 mr-2"
              (click)="closeModal()">Cancel</a>
              <a href="login" type="button" class="btn btn-primary mb-2"
                >Back to Login</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Coming soon ends-->